import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import Container from "../../../Components/ContainerControl";
import { PersonasReportStyled } from "./styles";
import { getRequestUserInfo } from "../../../Helpers/restClient";
import { TipoCuentas } from "../../../Helpers/Constant";
import { utils } from "../../../Helpers/utils";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import TableControl from "../../../Components/Controls/TableControl";
import { columnsPersonasReport } from "./settings";
import { PersonasReportService } from "./PersonasReport.Service";
import { Toast } from "primereact/toast";
import PhotoViewerModal from "./PhotoViewerModal";
import { FilterMatchMode } from "primereact/api";
import { useResidentials } from "../../../Hooks/useResidentials";

const PersonasReport = () => {
  const userInfo = useMemo(() => getRequestUserInfo(), []);
  const [residentialSelected, setResidentialSelected] = useState(null);
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selctedPersona, setSelctedPersona] = useState();
  const toast = useRef(null);
  const { residentials } = useResidentials();

  const canShowResidentialControl = useMemo(() => {
    const account = userInfo.accounts[0];
    const permission = account.accountType;
    return (
      permission === TipoCuentas.administrador ||
      utils.hasPermission("VerTodasLasResidenciales")
    );
  }, [userInfo]);

  const [filtersTable, setFiltersTable] = useState({
    personCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fullName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    identityNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    block: { value: null, matchMode: FilterMatchMode.CONTAINS },
    houseNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    residentialNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
    area: { value: null, matchMode: FilterMatchMode.CONTAINS },
    index: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    if (utils.evaluateArray(residentials)) {
      const account = userInfo.accounts[0];

      const _residentialSelected = residentials.find(
        (x) => x.residentialNo === account.residentialNo
      );

      setResidentialSelected(_residentialSelected || residentials[0]);
    }
  }, [residentials, userInfo]);

  const handleGenerateReport = async () => {
    if (!residentialSelected) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Por favor seleccione una residencial.",
        life: 3000,
      });
      return;
    }

    setLoading(true);
    const response = await PersonasReportService.generateReport(
      residentialSelected?.residentialNo
    );

    if (response.success) {
      const _personas = response.personas?.map((x, index) => ({
        ...x,
        index: index + 1,
      }));
      setPersonas(_personas);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          response.validationErrorMessage || "No se pudo generar el reporte.",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const handleShowImage = useCallback((item) => {
    setSelctedPersona(item);
  }, []);

  const columns = useMemo(
    () => columnsPersonasReport(handleShowImage),
    [handleShowImage]
  );

  return (
    <Container>
      <Toast ref={toast} position="top-center" />
      <PersonasReportStyled>
        <div className="report-header">
          {canShowResidentialControl && (
            <Dropdown
              value={residentialSelected}
              options={residentials}
              onChange={(e) => setResidentialSelected(e.value)}
              optionLabel="name"
              placeholder="Seleccione una Residencial"
              filter
              className="residential-dropdown"
            />
          )}

          {!canShowResidentialControl && <h2>{residentialSelected?.name}</h2>}

          <Button
            label={loading ? "Generando..." : "Generar"}
            icon="pi pi-refresh"
            onClick={handleGenerateReport}
            className="generate-button"
            disabled={loading}
            loading={loading}
          />
        </div>

        <div className="table-container">
          <div
            style={{
              textAlign: "right",
              marginRight: "30px",
              fontSize: "14pt",
              fontWeight: "bold",
            }}
          >
            Total de personas: {personas?.length}
          </div>
          {loading ? (
            <div className="loading-message">Cargando datos...</div>
          ) : (
            <TableControl
              items={personas}
              title="Reporte de Personas"
              columns={columns}
              emptyMessage={`No hay personas registradas en ${residentialSelected?.name}`}
              filter={filtersTable}
              setFilter={setFiltersTable}
              filterFields={Object.keys(filtersTable).map((x) => x)}
              isExportExcel
              fileName={`Reporte Personas ${residentialSelected?.name}`}
            />
          )}
        </div>
      </PersonasReportStyled>
      {selctedPersona && (
        <PhotoViewerModal
          isOpen={selctedPersona.photoUrl}
          onClose={() => setSelctedPersona(undefined)}
          person={selctedPersona}
        />
      )}
    </Container>
  );
};

export default PersonasReport;
